<script lang="ts">
    import parsePhoneNumber from 'libphonenumber-js';
    import { Table } from "attractions";
    import { onMount } from "svelte";
    import Employee from "../../Models/Employee";
    import RolesAutocomplete from '../RolesAutocomplete/RolesAutocomplete.svelte';
    import { EMPLOYEE_DETAILS } from '../../Stores/Session';

    const headers = [
        { text: 'Imię i nazwisko', value: 'name' },
        { text: 'Rola', value: 'role' },
        { text: 'Numer telefonu', value: 'phone' }
    ]

    let employeeDetails;
    let items = [];

    async function changeEmployeeRole(e, employee) {
        const desiredRole = e.detail.value;
        const res = await Employee.setRole(employee, desiredRole);
    }

    EMPLOYEE_DETAILS.subscribe(data => employeeDetails = data);

    onMount(async () => {
        const res = await Employee.getAll();
        items = res.map(employee => {
            const { _id, firstname, lastname, phone, role } = employee;
            return {
                _id,
                name: `${firstname} ${lastname} ${employeeDetails._id == _id ? '(ty)' : ''}`,
                phone: parsePhoneNumber(phone, 'PL').format('NATIONAL'),
                role: {
                    label: role.name,
                    value: role._id
                }
            }
        })
    })

</script>

{#if items && employeeDetails}
    <Table {headers} {items}>
        <div let:header let:item slot="item">
            {#if header.value == 'role'}
                <RolesAutocomplete on:select={e => changeEmployeeRole(e, item['_id'])} defaultOption={item[header.value]} disabled={item['_id'] == employeeDetails._id} styles="width: 200px" />
            {:else}
                {item[header.value]}
            {/if}
        </div>
    </Table>
{/if}